import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Response } from '../../../_shared/models';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { FuelLevel } from '../models/fuel-level.model';

@Injectable({
  providedIn: 'root'
})
export class FuelLevelService {

  private http: HttpClient = inject(HttpClient);

  public getFuelLevelsAsync(accountIds: number[], cancellation: Subject<void>): Promise<Response<FuelLevel[]>> {
    return firstValueFrom(this.http.post<Response<FuelLevel[]>>(`${environment.apiEndpoint}/fuellevel/search`, { accountIds }).pipe(takeUntil(cancellation)));
  }

  public getLowFuelLevelsAsync(accountIds: number[], cancellation: Subject<void>): Promise<Response<FuelLevel[]>> {
    return firstValueFrom(this.http.post<Response<FuelLevel[]>>(`${environment.apiEndpoint}/fuellevel/low/search`, { accountIds }).pipe(takeUntil(cancellation)));
  }

  public processLowFuelLevelAsync(fuelLevelId: number): Promise<Response<void>> {
    return firstValueFrom(this.http.post<Response<void>>(`${environment.apiEndpoint}/fuellevel/low/${fuelLevelId}/process`, null));
  }
}
